import React from 'react';
import Modal from './Modal';

// Union type for all possible options
export type SelectionOption = 
  | 'ENTERPRISE_OPEN_DEAL' 
  | 'ENTERPRISE_INVESTIGATE' 
  | 'TRANSACTIONAL_OPEN_DEAL' 
  | 'TRANSACTIONAL_INVESTIGATE' 
  | 'INVESTIGATE' 
  | 'FORGET' 
  | 'ALL';

interface SelectionItem {
  label: string;
  count: number;
  option: SelectionOption;
}

interface SelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  items: SelectionItem[];
  onSelectOption: (option: SelectionOption) => void;
  isLoading?: boolean;
}

const SelectionModal: React.FC<SelectionModalProps> = ({
  isOpen,
  onClose,
  title,
  items,
  onSelectOption,
  isLoading = false
}) => {
  const totalCount = items.reduce((sum, item) => sum + item.count, 0);

  const handleOptionClick = (option: SelectionOption) => {
    onSelectOption(option);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="max-w-md"
    >
      <div className="space-y-6">
        {isLoading ? (
          /* Loading state */
          <div className="flex flex-col items-center justify-center py-12 space-y-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
            <div className="text-gray-600 dark:text-gray-400 text-sm font-inter">Loading breakdown data...</div>
          </div>
        ) : (
          /* Clean breakdown display matching your design */
          <div className="space-y-4">
            {/* Total Count - Regular font weight */}
            <div
              className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg px-2 transition-colors"
              onClick={() => handleOptionClick('ALL')}
            >
              <div className="flex flex-col">
                <span className="text-gray-900 dark:text-gray-100 font-inter">Actionable Cycles</span>
                <span className="text-xs text-gray-500 dark:text-gray-400 font-inter">(excluding Bad Fit & Trash)</span>
              </div>
              <span className="text-gray-900 dark:text-gray-100 text-2xl font-inter">{totalCount}</span>
            </div>

            {/* Individual items - Bold */}
            {items.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg px-2 transition-colors"
                onClick={() => handleOptionClick(item.option)}
              >
                <span className="text-gray-900 dark:text-gray-100 font-bold font-inter">{item.label}</span>
                <span className="text-gray-900 dark:text-gray-100 font-bold text-2xl font-inter">{item.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SelectionModal;
